/**
 * Round 16 I14 -- a catalogue word where the catalogue has one, else the
 * fallback, asked with `exists` first: a value the catalogue has not
 * met (a new enum, a null code) is not a missing key to report.
 */
import type { TFunction } from "i18next";

import { i18n } from "shared/i18n";

export function said(
  t: TFunction,
  key: string,
  fallback: string,
  params: Record<string, unknown> = {},
): string {
  return i18n.exists(key) ? t(key, params) : fallback;
}
